module.exports = __webpack_public_path__ + "img/float-video-off.51fa09c8.svg";